import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/nav/top/link/page',
    method: 'get',
    params
  })
}

export function getById(id) {
  return request({
    url: `/nav/top/link/getById/${id}`,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: 'nav/top/link/',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/nav/top/link/',
    method: 'put',
    data
  })
}

export function remove(ids) {
  return request({
    url: `/nav/top/link/delete/${ids}`,
    method: 'delete'
  })
}

export function getMaxSort() {
  return request({
    url: '/nav/top/link/getMaxSort',
    method: 'get'
  })
}
